// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__Disclaimer__disclaimerContainer{margin-top:20px}", "",{"version":3,"sources":["webpack://./src/components/Disclaimer/Disclaimer.module.scss"],"names":[],"mappings":"AAAA,sCACI,eAAA","sourcesContent":[".disclaimerContainer{\n    margin-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"disclaimerContainer": "app__Disclaimer__disclaimerContainer"
};
export default ___CSS_LOADER_EXPORT___;
